import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, consultarFichaCadastral } from './types';

export const INITIAL_STATE: consultarFichaCadastral = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): consultarFichaCadastral {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_FICHA_CADASTRAL_REQUEST: {
				break;
			}

			case Types.CONSULTAR_FICHA_CADASTRAL_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CONSULTAR_FICHA_CADASTRAL_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CONSULTAR_FICHA_CADASTRAL_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
